import { useQuery } from '@tanstack/react-query';
import { ScheduleConfigService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useVacationRequestsByPartnerQuery = (
  partnerId: number,
  isEnabled: boolean
) =>
  useQuery({
    queryKey: queryKeys.schedule.vacationRequestsById(partnerId),
    queryFn: async () =>
      await ScheduleConfigService.scheduleConfigServiceGetVacationRequestsByPartner(
        {
          path: {
            partnerId,
          },
        }
      ),
    enabled: isEnabled,
  });
